import { CLASetting } from '../types';

import { CLA_YEAR_SETTINGS } from 'RestAPIs/endpoints';
import { useCreateResource } from 'RestAPIs/useCreateResource';
import { useUpdateResource } from 'RestAPIs/useUpdateResource';

export const useSaveWithCopy = (
  handleClose: () => void,
  isCopied: boolean,
  rowData?: CLASetting
) => {
  const editClaSetting = useUpdateResource({
    id: rowData?.claId ?? '',
    url: CLA_YEAR_SETTINGS,
    invalidateQueryKey: ['claYears']
  });
  const createClaSetting = useCreateResource({
    url: CLA_YEAR_SETTINGS,
    invalidateQueryKey: ['claYears']
  });

  return rowData && !isCopied ? editClaSetting : createClaSetting;
};
